export default __webpack_public_path__ + "3817d6d0f407d85cbaecef466206e6dc.svg";